import React from 'react';
interface SkeletonCardProps {
  height?: string;
  className?: string;
}
const SkeletonCard: React.FC<SkeletonCardProps> = ({
  height = 'h-32',
  className = ''
}) => {
  return <div className={`rounded-lg border border-gray-200 bg-white shadow-sm animate-pulse ${height} ${className}`} data-id="element-1164">
      <div className="h-full p-6 flex flex-col" data-id="element-1165">
        <div className="w-1/3 h-4 bg-gray-200 rounded mb-3" data-id="element-1166"></div>
        <div className="w-1/2 h-6 bg-gray-200 rounded mb-4" data-id="element-1167"></div>
        <div className="w-3/4 h-3 bg-gray-200 rounded mb-2" data-id="element-1168"></div>
        <div className="w-2/3 h-3 bg-gray-200 rounded" data-id="element-1169"></div>
      </div>
    </div>;
};
export default SkeletonCard;